import { shallUseTestMode } from '@/hooks/useTestMode';
import { type IApiResponse, type IScoreboard } from '@/types/INote';
import { type IPageData } from '@/types/IPageData';

export const craftFetchURL = ({ endpoint }: { endpoint: string; }): URL => {
  const isTestMode = shallUseTestMode();
  const origin = isTestMode ? 'https://live-api-test.wyborcza.pl' : 'https://live-api.wyborcza.pl';
  return new URL(endpoint, origin);
};

export const fetchScoreboardData = async ({ articleId }: { articleId: IPageData['articleId']; }): Promise<IScoreboard> => {
  const response = await globalThis.fetch(
    craftFetchURL({ endpoint: `/live/${articleId}/score-board` }),
    { cache: 'no-cache' },
  );
  return response.json();
};

export const fetchNotesAfterData = async ({ articleId, date = new Date(0), limit = 20 }: { articleId: IPageData['articleId']; date?: Date; limit?: number }): Promise<IApiResponse> => {
  const url = craftFetchURL({ endpoint: `/gazetapl/live/${articleId}/notes/after` });
  url.searchParams.set('dateTime', date.toJSON());
  url.searchParams.set('limit', limit.toString());
  url.searchParams.set('contextUrl', window.location.host);

  const response = await fetch(
    url,
    { cache: 'no-cache' },
  );
  return response.json();
};

export const fetchNotesBeforeData = async ({ articleId, date = new Date(), limit = 20 }: { articleId: IPageData['articleId']; date?: Date; limit?: number }): Promise<IApiResponse> => {
  const url = craftFetchURL({ endpoint: `/gazetapl/live/${articleId}/notes/before` });
  url.searchParams.set('dateTime', date.toJSON());
  url.searchParams.set('limit', limit.toString());
  url.searchParams.set('contextUrl', window.location.host);

  const response = await fetch(
    url,
    { cache: 'no-cache' },
  );
  return response.json();
};
